import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Users, Settings, BookImage } from "lucide-react";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState(location.pathname);

  useEffect(() => {
    setSelected(location.pathname);
  }, [location]);
  const handleNavigate = (path) => {
    setSelected(path);
    navigate(path);
  };

  return (
    <footer className="footer">
      <nav className="footer_nav">
        <button
          className={`footer_link ${selected === "/MenuCard" ? "active" : ""}`}
          onClick={() => handleNavigate("/MenuCard")}
        >
          <Home size={20} className={`icon  ${selected === "/MenuCard" ? "active" : ""}`}  />
          <span>Menu</span>
        </button>
        <button
          className={`footer_link ${
            selected === "/Appearance" ? "active" : ""
          }`}
          onClick={() => handleNavigate("/Appearance")}
        >
          <BookImage size={20} className={`icon  ${selected === "/Appearance" ? "active" : ""}`}/>
          <span>Appearance</span>
        </button>
        <button
          className={`footer_link ${selected === "/Analytics" ? "active" : ""}`}
          onClick={() => handleNavigate("/Analytics")}
        >
          <Users size={20} className={`icon  ${selected === "/Analytics" ? "active" : ""}`}/>
          <span>Analytics</span>
        </button>
        <button
          className={`footer_link ${selected === "/Settings" ? "active" : ""}`}
          onClick={() => handleNavigate("/Settings")}
        >
          <Settings size={20} className={`icon  ${selected === "/Settings" ? "active" : ""}`}/>
          <span>Settings</span>
        </button>
      </nav>
      {/* Optional Logout Button */}
      {/* <button className="footer_logout_btn">
        <LogOut size={20} />
        <span>Logout</span>
      </button> */}
    </footer>
  );
}

export default Footer;
